"use strict";
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const EngagementHighlyEngaged = (props) => {
  const { className, size = IconSize.Medium, color = "inherit", ...rest } = props;
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#716BF1",
        d: "M3.358 7.974 5.684 10.3c1.486-1.638 3.525-2.69 5.768-2.837V4.17c-3.191.148-6.033 1.585-8.094 3.804Z",
        opacity: 0.4
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#716BF1",
        d: "M2.647 8.814a12.879 12.879 0 0 0-2.64 6.694 1.643 1.643 0 1 0 3.273.309 9.577 9.577 0 0 1 1.713-4.657L2.647 8.814Z",
        opacity: 0.2
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#716BF1",
        d: "M12.547 7.462c2.242.148 4.282 1.2 5.768 2.838l2.325-2.326c-2.06-2.22-4.902-3.656-8.093-3.804v3.292Z",
        opacity: 0.6
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#716BF1",
        d: "M20.72 15.816a9.577 9.577 0 0 0-1.713-4.656l2.346-2.346a12.88 12.88 0 0 1 2.64 6.694 1.643 1.643 0 0 1-3.272.309Zm-2.76-1.691c.407-.05.622.467.299.72l-4.757 3.72a2.082 2.082 0 1 1-1.535-3.707l5.994-.733Z"
      }
    )
  );
};
export default EngagementHighlyEngaged;
